import { DataPoint, DataPointTreeBranch } from 'src/pages/SignInPage/_BLL/types';

export const isDataPointTreeBranch = (leaf: DataPointTreeBranch | DataPoint): leaf is DataPointTreeBranch => {
	return (leaf as DataPointTreeBranch).children !== undefined;
};
